<form name="schcLine22Form" novalidate autocomplete="off">
  <div class="modal-header">
    <h3 class="modal-title">{{modalTitle}}
      <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
      <i class="fa pull-right"
         [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
         style="margin-right: 10px; cursor: pointer;"
         (click)="minimise = !minimise"></i>
    </h3>
  </div>

  <div class="modal-body" [hidden]="minimise">
    @if (modalLoading) {
<div class="text-center" style="padding: 20px;">
      <i class="fa fa-spinner fa-pulse fa-2x"></i>
    </div>
}
    <div class="schc-line22-form" [hidden]="modalLoading">
      <div class="form-group row">
        <label class="col-sm-3 col-form-label">DRDFDI</label>
        <div class="col-sm-5">
          <input type="number"
                 class="form-control"
                 [(ngModel)]="drdfdi"
                 name="drdfdi"
                 placeholder="Enter DRDFDI amount"
                 (ngModelChange)="updateLine22Sum()">
        </div>
      </div>

      <div class="form-group row">
        <label class="col-sm-3 col-form-label">DRDGILTY</label>
        <div class="col-sm-5">
          <input type="number"
                 class="form-control"
                 [(ngModel)]="drdgilty"
                 name="drdgilty"
                 placeholder="Enter DRDGILTY amount"
                 (ngModelChange)="updateLine22Sum()">
        </div>
      </div>

      <div class="form-group row line22-total-row">
        <label class="col-sm-3 col-form-label line22-total-label">Line 22 Amount</label>
        <div class="col-sm-5">
          <input type="number"
                 class="form-control line22-total-input"
                 [ngModel]="line22SumAmt"
                 name="line22SumAmt"
                 [disabled]="true">
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-info btn-sm"
            type="button"
            [disabled]="crudLoading"
            (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i>&nbsp;</span>
}Save
    </button>
    <button class="btn btn-warning btn-sm"
            type="button"
            (click)="cancel()">Cancel</button>
  </div>
</form>
